<template>
    <div>
        <navbar></navbar>
        <img src="../assets/img/findworka-talents.png" class="__climgrtl"/>
        <div class="container">
            <p class="__portpnew">Precision Hiring for GDL Finance’s Investment App</p>
            <p class="__headin">The Challenge</p>
            <p class="__meetdname">GDL wanted to launch a secure, mobile-first investment platform that any Nigerian could use—but they lacked specialised tech talent and couldn’t afford long hiring cycles.</p>
            
            <p class="__headin">The Solution</p>
            <p class="__meetdname">Findworka scoped and delivered a lean, powerful trio:</p>
            <ul class="__portp2new">
                <li><b class="__namp">Node.js Backend Engineer – </b> Built and secured the investment logic and APIs.</li>
                <li><b class="__namp">Frontend Developer – </b> Crafted responsive, user-first interfaces.</li>
                <li><b class="__namp">Mobile Developer– </b> Brought the experience to life on Android & iOS.</li>
            </ul>
            <p class="__meetdname">Each engineer integrated seamlessly into GDL’s agile sprints to co-build the MVP.</p>
            
            <p class="__headin">Services Offered</p>
            <ul class="__portp2new">
                <li>Role scoping</li>
                <li>Pre-vetted talent shortlist</li>
                <li>Rapid onboarding</li>
                <li>Sprint integration</li>
                <li>Ongoing performance check-ins</li>
            </ul>

            <p class="__headin">Impact & Results (tile metrics)</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Time to MVP</span></p>
                        <p class="__meetdname">“Within months”</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Hiring Delays</span></p>
                        <p class="__meetdname">Zero</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Security Incidents</span></p>
                        <p class="__meetdname">Zero</p>
                    </div>
                </div>
            </div><br>

            <p class="__meetdname">GDL’s sleek, secure investment app launched to new and existing investors in record time—without compromising on talent quality or security. One-off hire, long-term value.</p>

            <p class="__headin">Tech Stack Deployed</p>
            <ul class="__portp2new">
                <li>Node.js</li>
                <li>React</li>
                <li>Flutter</li>
                <li>AWS Cognito</li>
                <li>JWT Auth</li>
            </ul>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“We came with a specific need, and Findworka delivered with precision. No guesswork. No delays. Just solid engineers who helped us build fast and right.” <span class="__namp"><i> — Product Lead, GDL Finance</i></span></p>

            <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-12">
                    <div class="text-center">
                        <p class="__hvsip">Need top-tier developers reliably and quickly?</p>
                        <p class="__meetdname">Tell us about the roles you’re hiring for, and receive pre-vetted profiles in under 72 hours. Whether you’re looking for individuals or building a team, you’ve come to the right place.</p>
                        <router-link to="/hire" class="btn __viewsite">Get Started Here </router-link>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
            </div>

            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/talentgdl.vue